import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiTrendingUp,FiZap,FiTarget,FiCheck,FiArrowRight,FiPhone,FiMail,FiMapPin,FiStar,FiDollarSign,FiClock,FiUsers,FiShield,FiGlobe,FiEdit3,FiSmartphone,FiSearch,FiVideo,FiBookOpen,FiAward}=FiIcons;

function Nigeria() {
  const packages=[ 
    {name: 'Business Growth Starter',description: 'Perfect for small businesses,startups,local service providers',features: [ 
      'Professional Blog Content - 4 SEO-optimized articles monthly',
      'Email Marketing Automation - 2 professional campaigns monthly',
      'Social Media Management - 12 engaging posts monthly',
      'Performance Tracking - Monthly reports',
      'Nigerian Market Optimization - Locally tailored content' 
    ],perfectFor: [ 
      'Local service businesses (salons,restaurants,repair services)',
      'Professional services (lawyers,accountants,consultants)',
      'Small retail businesses looking to grow online',
      'Startups needing professional marketing presence' 
    ],results: [ 
      '50-100% increase in website visitors within 90 days',
      '25-50 new qualified leads monthly',
      'Professional online presence that builds trust',
      'More time to focus on serving customers' 
    ]},
    {name: 'Professional Growth Accelerator',description: 'Perfect for established SMEs,professional firms,growing businesses',features: [ 
      'Comprehensive Content Strategy - 8 SEO-optimized blog posts monthly',
      'Advanced Email Marketing - 4 targeted campaigns with automation',
      'Multi-Platform Social Media - 20 professional posts monthly',
      'Lead Generation Assets - 2 valuable downloadable resources monthly',
      'Strategic Consultation - Bi-weekly strategy calls',
      'Dedicated Account Management - Personal account manager' 
    ],perfectFor: [ 
      'Manufacturing and trading companies',
      'Professional services firms with multiple locations',
      'E-commerce businesses scaling operations',
      'Companies expanding across Nigerian states' 
    ],results: [ 
      '100-200% increase in qualified leads within 6 months',
      'Improved customer retention and lifetime value',
      'Stronger brand recognition in your market',
      'Scalable marketing systems that grow with your business' 
    ],popular: true},
    {name: 'Enterprise Market Leadership',description: 'Perfect for large businesses,market leaders,companies with ambitious growth goals',features: [ 
      'Authority Content Creation - 12 in-depth articles monthly',
      'Sophisticated Email Marketing - 6 targeted campaigns',
      'Premium Social Media Presence - 30 high-quality posts monthly',
      'Thought Leadership Content - 4 premium resources monthly',
      'Weekly Strategy Optimization - Regular strategy calls',
      'Dedicated Marketing Team - Complete team support',
      'Quarterly Business Reviews - Comprehensive analysis sessions' 
    ],perfectFor: [ 
      'Established companies dominating their markets',
      'Businesses expanding nationally or internationally',
      'Companies in competitive industries needing differentiation',
      'Organizations requiring sophisticated marketing strategies' 
    ],results: [ 
      'Market leadership positioning within 12 months',
      '200-400% increase in high-value leads',
      'Significant improvement in customer acquisition costs',
      'Sustainable competitive advantages through content marketing' 
    ]} 
  ];

  const testimonials=[ 
    {name: 'Adebayo Ogundimu',title: 'CEO - Ogundimu Manufacturing Ltd,Lagos',quote: 'Before AllGrowth by Handvantage,we were struggling to find new customers consistently. Now we have more qualified leads than we can handle. Our sales have increased by 280% in just 8 months,and we\'ve been able to expand to two new locations.',results: '280% sales increase,expanded to 2 new locations'},
    {name: 'Dr. Funmi Adebayo',title: 'Managing Partner - Adebayo & Associates Legal,Abuja',quote: 'As a law firm,we needed to build trust and establish our expertise online. AllGrowth created a content strategy that positioned us as thought leaders in our field. We now get 5-7 new client inquiries every week,compared to 1-2 before.',results: '350% increase in client inquiries,established thought leadership'},
    {name: 'Chinedu Okwu',title: 'Founder - Okwu Fashion House,Port Harcourt',quote: 'We were spending too much time on social media and not seeing results. AllGrowth automated our entire marketing process and improved our content quality dramatically. Our online sales have tripled,and we now serve customers across all 36 states.',results: '300% increase in online sales,national expansion'} 
  ];

  const faqs=[ 
    {question: 'How quickly will we see results?',answer: 'Most of our Nigerian clients start seeing increased website traffic and engagement within the first 30 days. Significant lead generation improvements typically occur within 60-90 days. However,the timeline can vary based on your industry,competition,and current marketing foundation.'},
    {question: 'Do you understand the Nigerian market?',answer: 'Absolutely. AllGrowth by Handvantage has extensive experience working with Nigerian businesses across various industries. We understand local customer behavior,cultural nuances,business practices,and regulatory requirements. All our strategies are specifically adapted for the Nigerian market.'},
    {question: 'What if we\'re not satisfied with the results?',answer: 'We\'re confident in our ability to deliver results. If you\'re not satisfied with your progress after 90 days of working with us,we\'ll continue working with you at no additional cost until you achieve your goals. Your success is our success.'},
    {question: 'Can you work with businesses outside Lagos and Abuja?',answer: 'Yes! We work with businesses across all Nigerian states. Our digital approach means we can effectively serve clients in Port Harcourt,Kano,Ibadan,Enugu,and every other major city. We understand regional differences and adapt our strategies accordingly.'},
    {question: 'How do we get started?',answer: 'Simply schedule your complimentary Business Growth Assessment using the button below. We\'ll analyze your current marketing,identify opportunities,and create a custom strategy proposal for your business. There\'s no obligation,and you\'ll get valuable insights regardless of whether you decide to work with us.'} 
  ];

  return ( 
    <div> 
      {/* Hero Section */} 
      <section className="bg-gradient-to-br from-green-900 via-green-800 to-green-700 py-20"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <div className="flex items-center justify-center space-x-2 mb-4"> 
              <span className="text-4xl">🇳🇬</span> 
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white"> 
                Transform Your Nigerian Business 
              </h1> 
            </div> 
            <div className="text-green-100 mb-6"> 
              <span className="font-semibold text-white">AllGrowth by Handvantage</span> - Enterprise Growth Solutions for Nigeria 
            </div> 
            <p className="text-xl md:text-2xl text-green-100 mb-8 max-w-4xl mx-auto"> 
              Join successful Nigerian businesses using AllGrowth's advanced marketing automation to increase sales by 150%+,reduce marketing costs by 40%,and build lasting customer relationships that drive sustainable growth. 
            </p> 
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8"> 
              <Link 
                to="/book-consultation" 
                className="bg-white text-green-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-green-50 transition-colors" 
              > 
                Get Your Free Business Growth Assessment 
              </Link> 
              <a 
                href="https://wa.me/2362350919" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-green-900 transition-colors flex items-center justify-center space-x-2" 
              > 
                <span>📱</span> 
                <span>WhatsApp Us Now</span> 
              </a> 
            </div> 
            <div className="grid md:grid-cols-3 gap-4 max-w-4xl mx-auto text-green-100"> 
              <div className="flex items-center justify-center space-x-2"> 
                <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-300" /> 
                <span>Trusted by 100+ Nigerian Businesses</span> 
              </div> 
              <div className="flex items-center justify-center space-x-2"> 
                <SafeIcon icon={FiGlobe} className="h-5 w-5 text-green-300" /> 
                <span>International Expertise,Local Understanding</span> 
              </div> 
              <div className="flex items-center justify-center space-x-2"> 
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-green-300" /> 
                <span>Lagos,Abuja,Port Harcourt & Beyond</span> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Problem Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"> 
              The Marketing Challenges Every Nigerian Business Faces 
            </h2> 
            <p className="text-lg text-gray-600 max-w-3xl mx-auto"> 
              If you're a business owner in Nigeria,you know these struggles all too well: 
            </p> 
          </div> 
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12"> 
            {[ 
              {icon: FiDollarSign,title: 'Limited Marketing Budget,Maximum Expectations',description: 'You need results that justify every naira spent,but traditional marketing agencies charge premium rates for basic services that don\'t deliver measurable ROI.'},
              {icon: FiTrendingUp,title: 'Inconsistent Lead Generation',description: 'One month you have too many customers to handle,the next month you\'re wondering where your next client will come from. You need predictable,consistent growth.'},
              {icon: FiClock,title: 'Time-Consuming Manual Processes',description: 'You\'re spending hours on social media posts,email follow-ups,and content creation instead of focusing on serving customers and growing your business.'},
              {icon: FiUsers,title: 'Difficulty Competing with Larger Companies',description: 'Big corporations have marketing teams and unlimited budgets. You need smart strategies that level the playing field without breaking the bank.'},
              {icon: FiEdit3,title: 'Lack of Professional Marketing Materials',description: 'Your business deserves professional presentation,but quality design and content creation seems expensive and time-consuming.'},
              {icon: FiShield,title: 'Unreliable Marketing Partners',description: 'You\'ve worked with agencies that don\'t understand Nigerian business culture or deliver results that justify their fees.'} 
            ].map((problem,index)=> ( 
              <div key={index} className="bg-gray-50 p-6 rounded-xl"> 
                <div className="text-red-600 mb-4"> 
                  <SafeIcon icon={problem.icon} className="h-10 w-10" /> 
                </div> 
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{problem.title}</h3> 
                <p className="text-gray-600">{problem.description}</p> 
              </div> 
            ))} 
          </div> 
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center"> 
            <p className="text-lg text-gray-700"> 
              <strong className="text-red-700">The Reality:</strong> 78% of Nigerian SMEs struggle with consistent marketing,and 65% report that poor marketing is their biggest growth barrier <span className="text-red-600 font-semibold"> (according to recent SMEDAN research)</span>. 
            </p> 
          </div> 
        </div> 
      </section> 

      {/* Solution Section */} 
      <section className="py-16 bg-green-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"> 
              AllGrowth: AI-Powered Marketing Solutions Built for Nigerian Businesses 
            </h2> 
            <p className="text-xl text-gray-600 max-w-4xl mx-auto"> 
              We understand the unique challenges of doing business in Nigeria. That's why AllGrowth by Handvantage has created marketing solutions that work specifically for the Nigerian market: 
            </p> 
          </div> 
          <div className="grid lg:grid-cols-2 gap-12 items-center"> 
            <div className="space-y-8"> 
              {[ 
                {icon: FiDollarSign,title: 'Smart,Budget-Friendly Marketing',description: 'Get enterprise-level marketing strategies at prices that make sense for Nigerian businesses. Our AI-powered approach delivers better results at a fraction of traditional agency costs.'},
                {icon: FiTarget,title: 'Predictable Lead Generation',description: 'Build a consistent pipeline of qualified customers through strategic content marketing,email automation,and social media management that works 24/7.'},
                {icon: FiZap,title: 'Automated Systems That Save Time',description: 'Focus on running your business while our automated systems handle content creation,customer follow-up,and lead nurturing without constant supervision.'},
                {icon: FiAward,title: 'Professional Brand Presence',description: 'Establish your business as the trusted authority in your industry with professional content,consistent messaging,and strategic online presence.'},
                {icon: FiMapPin,title: 'Local Market Expertise',description: 'We understand Nigerian business culture,customer behavior,and market dynamics. Our strategies are designed specifically for the Nigerian market.'} 
              ].map((solution,index)=> ( 
                <div key={index} className="flex items-start space-x-4"> 
                  <div className="flex-shrink-0"> 
                    <SafeIcon icon={solution.icon} className="h-8 w-8 text-green-600" /> 
                  </div> 
                  <div> 
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{solution.title}</h3> 
                    <p className="text-gray-600">{solution.description}</p> 
                  </div> 
                </div> 
              ))} 
            </div> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">What Nigerian Businesses Get with AllGrowth</h3> 
              <ul className="space-y-4"> 
                {[ 
                  'AI-powered blog content that ranks and converts',
                  'Email marketing campaigns that nurture leads',
                  'Social media posts that build local trust',
                  'SEO-optimized pages that dominate local search',
                  'Lead magnets that capture email addresses',
                  'Monthly strategy calls and performance reports',
                  'Content optimized for Nigerian culture and language',
                  'Strategies that work across all Nigerian states' 
                ].map((item,index)=> ( 
                  <li key={index} className="flex items-start space-x-3"> 
                    <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                    <span className="text-gray-700">{item}</span> 
                  </li> 
                ))} 
              </ul> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Services Packages Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Complete AllGrowth Marketing Solutions for Growing Nigerian Businesses 
            </h2> 
          </div> 
          <div className="space-y-16"> 
            {packages.map((pkg,index)=> ( 
              <div key={index} className="bg-gray-50 rounded-2xl p-8 lg:p-12"> 
                <div className="grid lg:grid-cols-3 gap-8"> 
                  <div className="lg:col-span-2"> 
                    <div className="flex items-center space-x-4 mb-6"> 
                      {pkg.popular && ( 
                        <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-1"> 
                          <SafeIcon icon={FiStar} className="h-4 w-4" /> 
                          <span>Most Popular</span> 
                        </span> 
                      )} 
                      <h3 className="text-2xl font-bold text-gray-900">{pkg.name}</h3> 
                    </div> 
                    <p className="text-lg text-gray-600 mb-8">{pkg.description}</p> 
                    <div className="mb-8"> 
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">What's Included:</h4> 
                      <ul className="space-y-2"> 
                        {pkg.features.map((feature,idx)=> ( 
                          <li key={idx} className="flex items-start space-x-3"> 
                            <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                            <span className="text-gray-700">{feature}</span> 
                          </li> 
                        ))} 
                      </ul> 
                    </div> 
                    <div className="mb-8"> 
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Perfect For:</h4> 
                      <ul className="space-y-2"> 
                        {pkg.perfectFor.map((item,idx)=> ( 
                          <li key={idx} className="flex items-start space-x-3"> 
                            <SafeIcon icon={FiArrowRight} className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" /> 
                            <span className="text-gray-700">{item}</span> 
                          </li> 
                        ))} 
                      </ul> 
                    </div> 
                  </div> 
                  <div className="bg-white rounded-xl p-6 shadow-lg h-fit"> 
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Results You Can Expect:</h4> 
                    <ul className="space-y-3 mb-6"> 
                      {pkg.results.map((result,idx)=> ( 
                        <li key={idx} className="flex items-start space-x-3"> 
                          <SafeIcon icon={FiTrendingUp} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                          <span className="text-gray-700">{result}</span> 
                        </li> 
                      ))} 
                    </ul> 
                    <Link 
                      to="/book-consultation" 
                      className="block w-full text-center bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors" 
                    > 
                      Get Custom Pricing 
                    </Link> 
                  </div> 
                </div> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Why Choose AllGrowth Section */} 
      <section className="py-16 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Why Nigerian Businesses Choose AllGrowth by Handvantage 
            </h2> 
          </div> 
          <div className="grid md:grid-cols-2 gap-12 mb-16"> 
            <div className="space-y-8"> 
              <div> 
                <h3 className="text-2xl font-bold text-gray-900 mb-4">We Understand the Nigerian Market</h3> 
                <p className="text-lg text-gray-600 mb-4"> 
                  <strong>Local Expertise,International Standards</strong> 
                </p> 
                <p className="text-gray-600 mb-4"> 
                  Unlike foreign agencies that don't understand Nigerian business culture,AllGrowth knows how Nigerian customers think,buy,and make decisions. Our strategies are designed specifically for the Nigerian market. 
                </p> 
                <ul className="space-y-2"> 
                  {[ 
                    'Content that resonates with Nigerian audiences',
                    'Marketing strategies that work across different Nigerian regions',
                    'Understanding of local business practices and customer behavior',
                    'Compliance with Nigerian business regulations and standards' 
                  ].map((item,idx)=> ( 
                    <li key={idx} className="flex items-start space-x-3"> 
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                      <span className="text-gray-700">{item}</span> 
                    </li> 
                  ))} 
                </ul> 
              </div> 
              <div> 
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Advanced Technology,Affordable Investment</h3> 
                <p className="text-lg text-gray-600 mb-4"> 
                  <strong>Enterprise-Level Marketing at SME-Friendly Prices</strong> 
                </p> 
                <p className="text-gray-600 mb-4"> 
                  We use the same advanced marketing technologies that multinational corporations use,but at prices that make sense for Nigerian businesses. 
                </p> 
                <ul className="space-y-2"> 
                  {[ 
                    'AI-powered content creation and optimization',
                    'Advanced automation that works 24/7',
                    'Professional design and brand development',
                    'Comprehensive analytics and performance tracking' 
                  ].map((item,idx)=> ( 
                    <li key={idx} className="flex items-start space-x-3"> 
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                      <span className="text-gray-700">{item}</span> 
                    </li> 
                  ))} 
                </ul> 
              </div> 
            </div> 
            <div className="space-y-8"> 
              <div> 
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Proven Results for Nigerian Businesses</h3> 
                <p className="text-lg text-gray-600 mb-4"> 
                  <strong>Real Success Stories from Real Nigerian Companies</strong> 
                </p> 
                <p className="text-gray-600 mb-4"> 
                  We don't just promise results – we deliver them. Our AllGrowth clients across Lagos,Abuja,Port Harcourt,and other major cities have seen transformational growth. 
                </p> 
                <ul className="space-y-2"> 
                  {[ 
                    'Manufacturing company in Lagos: 300% increase in qualified leads',
                    'Professional services firm in Abuja: 250% growth in new client acquisition',
                    'E-commerce business in Port Harcourt: 400% improvement in online sales',
                    'Restaurant chain across Nigeria: 180% increase in customer retention' 
                  ].map((item,idx)=> ( 
                    <li key={idx} className="flex items-start space-x-3"> 
                      <SafeIcon icon={FiTrendingUp} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                      <span className="text-gray-700">{item}</span> 
                    </li> 
                  ))} 
                </ul> 
              </div> 
              <div> 
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Complete Support and Training</h3> 
                <p className="text-lg text-gray-600 mb-4"> 
                  <strong>We Don't Just Do the Work – We Teach You Too</strong> 
                </p> 
                <p className="text-gray-600 mb-4"> 
                  Our goal is your long-term success. That's why AllGrowth provides comprehensive training and support so your team can understand and contribute to your marketing success. 
                </p> 
                <ul className="space-y-2"> 
                  {[ 
                    'Regular training sessions for your team',
                    'Clear explanations of all strategies and tactics',
                    'Ongoing support and consultation',
                    'Resources and tools for continued learning' 
                  ].map((item,idx)=> ( 
                    <li key={idx} className="flex items-start space-x-3"> 
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                      <span className="text-gray-700">{item}</span> 
                    </li> 
                  ))} 
                </ul> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Testimonials Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              What Nigerian Business Owners Say About AllGrowth 
            </h2> 
          </div> 
          <div className="grid md:grid-cols-3 gap-8"> 
            {testimonials.map((testimonial,index)=> ( 
              <div key={index} className="bg-gray-50 p-8 rounded-xl"> 
                <div className="flex items-center mb-4"> 
                  {[...Array(5)].map((_,i)=> ( 
                    <SafeIcon key={i} icon={FiStar} className="h-5 w-5 text-yellow-400" /> 
                  ))} 
                </div> 
                <blockquote className="text-gray-700 mb-6 italic"> 
                  "{testimonial.quote}" 
                </blockquote> 
                <div className="border-t pt-4"> 
                  <div className="font-semibold text-gray-900">{testimonial.name}</div> 
                  <div className="text-gray-600 text-sm mb-2">{testimonial.title}</div> 
                  <div className="text-green-600 font-semibold text-sm"> 
                    <strong>Results:</strong> {testimonial.results} 
                  </div> 
                </div> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Process Section */} 
      <section className="py-16 bg-green-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              How AllGrowth Transforms Your Business in 90 Days 
            </h2> 
          </div> 
          <div className="grid md:grid-cols-3 gap-8"> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <div className="text-center mb-6"> 
                <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4"> 
                  1 
                </div> 
                <h3 className="text-xl font-bold text-gray-900">Discovery & Strategy</h3> 
                <p className="text-gray-600">Days 1-14</p> 
              </div> 
              <div className="space-y-4"> 
                <div> 
                  <h4 className="font-semibold text-gray-900 mb-2">Week 1: Business Analysis</h4> 
                  <ul className="space-y-1 text-sm text-gray-600"> 
                    <li>• Comprehensive analysis of your current marketing</li> 
                    <li>• Competitor research and market positioning</li> 
                    <li>• Target audience identification and profiling</li> 
                    <li>• Goal setting and success metrics definition</li> 
                  </ul> 
                </div> 
                <div> 
                  <h4 className="font-semibold text-gray-900 mb-2">Week 2: Strategy Development</h4> 
                  <ul className="space-y-1 text-sm text-gray-600"> 
                    <li>• Custom marketing strategy creation</li> 
                    <li>• Content calendar and campaign planning</li> 
                    <li>• Automation workflow design</li> 
                    <li>• Team training and onboarding preparation</li> 
                  </ul> 
                </div> 
              </div> 
            </div> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <div className="text-center mb-6"> 
                <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4"> 
                  2 
                </div> 
                <h3 className="text-xl font-bold text-gray-900">Implementation & Launch</h3> 
                <p className="text-gray-600">Days 15-45</p> 
              </div> 
              <div className="space-y-4"> 
                <div> 
                  <h4 className="font-semibold text-gray-900 mb-2">Weeks 3-4: Foundation Building</h4> 
                  <ul className="space-y-1 text-sm text-gray-600"> 
                    <li>• Professional content creation begins</li> 
                    <li>• Email marketing automation setup</li> 
                    <li>• Social media optimization and scheduling</li> 
                    <li>• Performance tracking implementation</li> 
                  </ul> 
                </div> 
                <div> 
                  <h4 className="font-semibold text-gray-900 mb-2">Weeks 5-6: Campaign Launch</h4> 
                  <ul className="space-y-1 text-sm text-gray-600"> 
                    <li>• Full marketing campaigns go live</li> 
                    <li>• Lead generation systems activated</li> 
                    <li>• Customer engagement automation begins</li> 
                    <li>• Initial performance monitoring and optimization</li> 
                  </ul> 
                </div> 
              </div> 
            </div> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <div className="text-center mb-6"> 
                <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4"> 
                  3 
                </div> 
                <h3 className="text-xl font-bold text-gray-900">Optimization & Growth</h3> 
                <p className="text-gray-600">Days 46-90</p> 
              </div> 
              <div className="space-y-4"> 
                <div> 
                  <h4 className="font-semibold text-gray-900 mb-2">Weeks 7-10: Performance Optimization</h4> 
                  <ul className="space-y-1 text-sm text-gray-600"> 
                    <li>• Campaign performance analysis and improvement</li> 
                    <li>• Content strategy refinement based on results</li> 
                    <li>• Lead generation optimization</li> 
                    <li>• Customer conversion rate improvement</li> 
                  </ul> 
                </div> 
                <div> 
                  <h4 className="font-semibold text-gray-900 mb-2">Weeks 11-12: Scaling Preparation</h4> 
                  <ul className="space-y-1 text-sm text-gray-600"> 
                    <li>• Advanced automation implementation</li> 
                    <li>• Team training for ongoing management</li> 
                    <li>• Long-term growth strategy development</li> 
                    <li>• Sustainable systems establishment</li> 
                  </ul> 
                </div> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* FAQ Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl font-bold text-gray-900 mb-4"> 
              Frequently Asked Questions 
            </h2> 
          </div> 
          <div className="space-y-8"> 
            {faqs.map((faq,index)=> ( 
              <div key={index} className="bg-gray-50 rounded-lg p-6"> 
                <h3 className="text-lg font-semibold text-gray-900 mb-3"> 
                  {faq.question} 
                </h3> 
                <p className="text-gray-600"> 
                  {faq.answer} 
                </p> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Investment Section */} 
      <section className="py-16 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Investment in Your Business Growth 
            </h2> 
          </div> 
          <div className="grid md:grid-cols-2 gap-12 items-center"> 
            <div> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Transparent,Value-Based Investment</h3> 
              <p className="text-lg text-gray-600 mb-8"> 
                AllGrowth believes in transparent pricing that delivers exceptional value for Nigerian businesses. Our investment levels are designed to provide maximum ROI while fitting within realistic business budgets. 
              </p> 
              <div className="space-y-4 mb-8"> 
                <h4 className="text-lg font-semibold text-gray-900">What's Included in Every Package:</h4> 
                <ul className="space-y-2"> 
                  {[ 
                    'Complete marketing strategy and implementation',
                    'Professional content creation and management',
                    'Advanced automation and technology',
                    'Dedicated account management and support',
                    'Regular performance reporting and optimization',
                    'Ongoing training and consultation' 
                  ].map((item,idx)=> ( 
                    <li key={idx} className="flex items-start space-x-3"> 
                      <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                      <span className="text-gray-700">{item}</span> 
                    </li> 
                  ))} 
                </ul> 
              </div> 
            </div> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Flexible Payment Options</h3> 
              <div className="space-y-4 mb-6"> 
                <div className="flex items-center space-x-3"> 
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500" /> 
                  <span className="text-gray-700">Monthly payment plans available</span> 
                </div> 
                <div className="flex items-center space-x-3"> 
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500" /> 
                  <span className="text-gray-700">Quarterly payment discounts</span> 
                </div> 
                <div className="flex items-center space-x-3"> 
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500" /> 
                  <span className="text-gray-700">Annual payment savings</span> 
                </div> 
                <div className="flex items-center space-x-3"> 
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500" /> 
                  <span className="text-gray-700">Multiple payment methods (bank transfer,mobile money)</span> 
                </div> 
              </div> 
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6"> 
                <h4 className="font-semibold text-green-800 mb-2">ROI Guarantee:</h4> 
                <p className="text-green-700"> 
                  We're so confident in AllGrowth's ability to grow your business that we guarantee you'll see measurable improvements in your marketing performance within 90 days,or we'll continue working with you until you do. 
                </p> 
              </div> 
              <Link 
                to="/book-consultation" 
                className="block w-full text-center bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors" 
              > 
                Schedule Your Free Assessment 
              </Link> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Final CTA Section */} 
      <section className="py-16 bg-green-900"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> 
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6"> 
            Ready to Transform Your Business with AllGrowth's AI-Powered Marketing? 
          </h2> 
          <p className="text-xl text-green-100 mb-8 max-w-4xl mx-auto"> 
            Join hundreds of successful Nigerian businesses using AllGrowth by Handvantage. Don't let another month pass wondering where your next customers will come from. Take the first step toward predictable,sustainable business growth. 
          </p> 
          <div className="bg-white/10 rounded-xl p-6 max-w-3xl mx-auto mb-10"> 
            <h3 className="text-xl font-semibold text-white mb-6"> 
              Schedule Your FREE Business Growth Assessment Today 
            </h3> 
            <p className="text-green-100 mb-6"> 
              In this complimentary 60-minute session,you'll discover: 
            </p> 
            <div className="grid md:grid-cols-2 gap-4 text-left"> 
              {[ 
                'Hidden Growth Opportunities - Identify untapped marketing opportunities specific to your business',
                'Custom Strategy Roadmap - Get a personalized plan for achieving your growth goals',
                'Competitive Analysis - Understand how you compare to competitors and how to gain advantages',
                'ROI Projections - See exactly how much growth you can expect from strategic marketing',
                'Implementation Timeline - Get a clear roadmap for transforming your marketing in 90 days' 
              ].map((item,idx)=> ( 
                <li key={idx} className="flex items-start space-x-3"> 
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-300 mt-0.5 flex-shrink-0" /> 
                  <span className="text-green-100">{item}</span> 
                </li> 
              ))} 
            </div> 
          </div> 
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8"> 
            <Link 
              to="/book-consultation" 
              className="bg-white text-green-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-green-50 transition-colors" 
            > 
              Schedule My FREE Assessment Now 
            </Link> 
            <a 
              href="tel:+2362350919" 
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-green-900 transition-colors flex items-center justify-center space-x-2" 
            > 
              <SafeIcon icon={FiPhone} className="h-5 w-5" /> 
              <span>Call: +234 (0) 236 235 0919</span> 
            </a> 
          </div> 
          <div className="grid md:grid-cols-3 gap-4 max-w-4xl mx-auto text-green-200 text-sm"> 
            <div className="flex items-center justify-center space-x-2"> 
              <SafeIcon icon={FiShield} className="h-4 w-4" /> 
              <span>100% Confidential - Your Information is Protected</span> 
            </div> 
            <div className="flex items-center justify-center space-x-2"> 
              <SafeIcon icon={FiUsers} className="h-4 w-4" /> 
              <span>No Sales Pressure - Just Valuable Insights</span> 
            </div> 
            <div className="flex items-center justify-center space-x-2"> 
              <SafeIcon icon={FiAward} className="h-4 w-4" /> 
              <span>Trusted by Nigerian Business Leaders</span> 
            </div> 
          </div> 
          <div className="mt-8 p-4 bg-yellow-500 text-yellow-900 rounded-lg max-w-md mx-auto"> 
            <p className="font-semibold">⚡ Limited Availability: We only conduct 10 assessments per month</p> 
          </div> 
        </div> 
      </section> 

      {/* Contact Information Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl font-bold text-gray-900 mb-4"> 
              Get in Touch - AllGrowth Nigeria 
            </h2> 
            <p className="text-gray-600"> 
              A product of <span className="font-semibold text-gray-900">Handvantage Corporation</span> 
            </p> 
          </div> 
          <div className="grid md:grid-cols-2 gap-12"> 
            <div> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3> 
              <div className="space-y-6"> 
                <div className="flex items-start space-x-4"> 
                  <div className="flex-shrink-0 p-3 bg-green-100 rounded-lg"> 
                    <SafeIcon icon={FiPhone} className="h-6 w-6 text-green-600" /> 
                  </div> 
                  <div> 
                    <h4 className="text-lg font-semibold text-gray-900 mb-1">Phone</h4> 
                    <a 
                      href="tel:+2362350919" 
                      className="text-green-600 hover:text-green-700 transition-colors" 
                    > 
                      +234 (0) 236 235 0919 
                    </a> 
                  </div> 
                </div> 
                <div className="flex items-start space-x-4"> 
                  <div className="flex-shrink-0 p-3 bg-green-100 rounded-lg"> 
                    <SafeIcon icon={FiMail} className="h-6 w-6 text-green-600" /> 
                  </div> 
                  <div> 
                    <h4 className="text-lg font-semibold text-gray-900 mb-1">Email</h4> 
                    <a 
                      href="mailto:info@handvantage.com" 
                      className="text-green-600 hover:text-green-700 transition-colors" 
                    > 
                      info@handvantage.com 
                    </a> 
                  </div> 
                </div> 
                <div className="flex items-start space-x-4"> 
                  <div className="flex-shrink-0 p-3 bg-green-100 rounded-lg"> 
                    <span className="text-2xl">📱</span> 
                  </div> 
                  <div> 
                    <h4 className="text-lg font-semibold text-gray-900 mb-1">WhatsApp</h4> 
                    <a 
                      href="https://wa.me/2362350919" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-green-600 hover:text-green-700 transition-colors" 
                    > 
                      +234 (0) 236 235 0919 
                    </a> 
                  </div> 
                </div> 
                <div className="bg-gray-50 p-4 rounded-lg"> 
                  <h4 className="font-semibold text-gray-900 mb-2">Business Hours:</h4> 
                  <div className="text-gray-600 space-y-1"> 
                    <p>Monday - Friday: 8:00 AM - 6:00 PM (WAT)</p> 
                    <p>Saturday: 9:00 AM - 2:00 PM (WAT)</p> 
                    <p>Sunday: Closed</p> 
                  </div> 
                </div> 
              </div> 
            </div> 
            <div> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">We Serve Businesses Across Nigeria</h3> 
              <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mb-8"> 
                {[ 
                  'Lagos','Abuja','Port Harcourt','Kano','Ibadan','Enugu','Kaduna','Jos','Benin City','Maiduguri','Zaria','Aba','Ilorin','Onitsha','Warri','Sokoto','Calabar','Uyo','Abeokuta','Akure' 
                ].map((city,idx)=> ( 
                  <div key={idx} className="flex items-center space-x-2"> 
                    <SafeIcon icon={FiMapPin} className="h-4 w-4 text-green-600" /> 
                    <span>{city}</span> 
                  </div> 
                ))} 
              </div> 
              <div className="bg-green-50 border border-green-200 rounded-lg p-6"> 
                <h4 className="font-semibold text-green-800 mb-3">International Headquarters:</h4> 
                <div className="text-green-700 space-y-1"> 
                  <p><strong>Handvantage Corporation</strong></p> 
                  <p>Vancouver,BC,Canada</p> 
                  <p>Delaware,USA</p> 
                </div> 
                <div className="mt-4 pt-4 border-t border-green-200"> 
                  <p className="text-sm text-green-600"> 
                    AllGrowth is a specialized marketing solution powered by Handvantage's enterprise-grade infrastructure 
                  </p> 
                </div> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 
    </div> 
  );
}

export default Nigeria;